import { render, staticRenderFns } from "./addSericeOrder.vue?vue&type=template&id=61668ccf&scoped=true"
import script from "./addSericeOrder.vue?vue&type=script&lang=js"
export * from "./addSericeOrder.vue?vue&type=script&lang=js"
import style0 from "./addSericeOrder.vue?vue&type=style&index=0&id=61668ccf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61668ccf",
  null
  
)

export default component.exports